export const separateNumberWithCommas = (numberWithoutCommas) => {
    numberWithoutCommas = numberWithoutCommas;
    const numberWithCommas = numberWithoutCommas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return numberWithCommas;
};

export const removeCommasFromNumber = (numberWithCommas) => {
    const numberWithoutCommas = numberWithCommas.replaceAll(",", "");
    return numberWithoutCommas;
};

// If float is a whole number = return the number without the decimal. Else = return with decimal.
export const displayPercentInput = (number) => {
    const decimalIndex = number.toFixed(2).indexOf(".");
    
    if (number.toFixed(2).slice(decimalIndex + 1) === "0") {
        return Math.round(number);
    } else return parseFloat(number.toFixed(2));
};

export const isNumberInfinity = (number) => {
    return number === Infinity;
};